import * as React from 'react';

import styles from './VerificationSuccess.module.scss';

//tr
import { tr } from '../../utils/translations/translator';
import { useTranslation } from 'react-i18next';
//assets
import logo from '../../assets/logo.svg';
import SVG from 'react-inlinesvg';
import ilu from '../../assets/ilu_18.png';
export interface VerificationSuccessProps {}

export const VerificationSuccess: React.FC<VerificationSuccessProps> = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.layoutHeader}>
        <a href={'https://www.tipsterchat.com/home'}>
          <SVG src={logo} />
        </a>
        <ul>
          <li>
            <a href={'https://www.tipsterchat.com/store'} target="blank">
              <button>{t('download_app')}</button>
            </a>
          </li>
        </ul>
      </div>
      <div className={styles.container}>
        <img alt="hi!" src={ilu} />
        <h1>
          {tr(t, 'acc-verification_success')} <br />
        </h1>
        <p> {tr(t, 'acc-verification_success-2')}</p>
      </div>
    </>
  );
};
